import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, inject, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { PreloadAllModules, provideRouter, RouteReuseStrategy, withPreloading } from '@angular/router';
import { InMemoryCache } from '@apollo/client';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';
import { provideTransloco, TranslocoService } from '@jsverse/transloco';
import Aura from '@primeuix/themes/aura';

import { HeaderInterceptor } from './app/_interceptors/header.interceptor';
import { HttpErrorInterceptor } from './app/_interceptors/http-error.interceptor';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { preloadTransloco } from './app/preloadTranslocoJson';
import { environment } from './environments/environment';
import { TranslocoHttpLoader } from './transloco-loader';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptorsFromDi()),
    provideTransloco({
      config: {
        availableLangs: environment.availableLangs,
        defaultLang: environment.defaultLang,
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: preloadTransloco,
      deps: [TranslocoService],
      multi: true,
    },
    provideApollo(() => {
      const httpLink = inject(HttpLink);

      return {
        link: httpLink.create({
          uri: environment.gqlBaseUrl,
        }),
        cache: new InMemoryCache(),
        defaultOptions: {
          query: { fetchPolicy: 'network-only' },
          mutate: { fetchPolicy: 'network-only' },
        },
      };
    }),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '<%= system %>',
        },
      },
      ripple: true,
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HeaderInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    MessageService,
  ],
});
